var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom-control",class:{
        outline: _vm.variant === 'outline' && _vm.type !== 'switch',
        'custom-switch': _vm.type === 'switch',
        'custom-checkbox': _vm.type !== 'switch',
        mirror: _vm.mirror,
    }},[_c('input',{staticClass:"custom-control-input",attrs:{"id":_vm.id,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"click":() => _vm.onChange({ target: { checked: !_vm.value } })}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }